import { Component, inject } from '@angular/core';
import { NgStyle } from '@angular/common';
import { IconDirective } from '@coreui/icons-angular';
import {
  ContainerComponent,
  RowComponent,
  ColComponent,
  CardGroupComponent,
  TextColorDirective,
  CardComponent,
  CardBodyComponent,
  FormDirective,
  InputGroupComponent,
  InputGroupTextDirective,
  FormControlDirective,
  ButtonDirective,
  AlertComponent,
  ToastComponent,
  ToastBodyComponent,
  ButtonCloseDirective,
  ToasterComponent,
} from '@coreui/angular';
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { AuthService } from '../../services/auth';
import { finalize } from 'rxjs';
import { Router } from '@angular/router';
import { ToastService } from '../../services/toast.service';
import { VersionService } from '../../services/version.service';
import { environments } from '../../../environments/environments';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  standalone: true,
  imports: [
    AlertComponent,
    ContainerComponent,
    RowComponent,
    ColComponent,
    CardGroupComponent,
    TextColorDirective,
    CardComponent,
    CardBodyComponent,
    FormDirective,
    InputGroupComponent,
    InputGroupTextDirective,
    IconDirective,
    FormControlDirective,
    ButtonDirective,
    NgStyle,
    ReactiveFormsModule,
    ToasterComponent,
    ToastComponent,
    ToastBodyComponent,
    ButtonCloseDirective,
  ],
})
export class LoginComponent {
  private _formBuilder: FormBuilder = inject(FormBuilder);
  private _AuthService: AuthService = inject(AuthService);
  private _router: Router = inject(Router);
  private toastService = inject(ToastService);
  private versionService = inject(VersionService);

  loginGroup: FormGroup = this._formBuilder.group({
    email: ['', [Validators.required, Validators.email]],
    password: ['', Validators.required],
  });

  errorMessage: string | null = null;
  loadingState: boolean = false;
  showPassword: boolean = false;
  currentYear: number = new Date().getFullYear();
  version: string = this.versionService.version;
  landingUrl: string = environments.appUrls.landing;
  developerUrl: string = environments.appUrls.developer;

  constructor() {}

  onSubmit() {
    if (this.loginGroup.invalid) return;
    // console.log('login value', this.loginGroup.value);
    this.loadingState = true;
    this.loginGroup.disable();
    this.errorMessage = null;
    this._AuthService
      .onLogin(this.loginGroup.value)
      .pipe(
        finalize(() => {
          this.loginGroup.enable();
          this.loadingState = false;
        }),
      )
      .subscribe({
        error: (error: any) => {
          /* this.errorMessage = `Ha ocurrido un error. Intentalo más tarde. (${error.statusText})`;
           if(typeof error.error == 'string')
          this.errorMessage = error.error; */
          this.toastService.show({
            color: 'warning',
            header: 'Error',
            // El 429 del throttle llega como { message }; el 401 del login, como texto
            message: error.error?.message ?? error.error,
          });
        },
      });
  }
}
